module.exports = __webpack_public_path__ + "static/media/DeepCBCT_analysis_auto.9d5e312a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/DeepCBCT_analysis_auto.svg
// module id = 1028
// module chunks = 0